<template>
  <div class="textProofreading">
    <div class="loading_box" v-show="loading">
      <div>当前用时： {{ currentTime.second }}秒</div>
      <div>预计用时： {{ estimated.time }}秒</div>
      <div class="percentage_">
        <el-progress
          :percentage="percentage"
          color="#409eff"
          class="percentage"
        />
        <el-button
          type="primary"
          :icon="isContinue ? 'el-icon-video-pause' : 'el-icon-video-play'"
          size="mini"
          circle
          @click="handlerSuspend"
        />
        <el-button
          icon="el-icon-circle-close"
          size="mini"
          circle
          @click="hanldeStop"
        />
      </div>
    </div>
    <div class="content" v-show="!loading">
      <div class="error" v-if="errorStatistics.list.length > 0">
        <div class="total">
          共提示错误{{ errorStatistics.list.length }}处，错误类型{{ errorTypeCount }}种
        </div>
        <div class="tag">
          <p>本次校对扫描用时{{ currentTime.time }}</p>
          <!-- <p>建议一准确率优先模式再次校对，对比结果</p> -->
        </div>
        <el-button type="primary" size="medium" plain @click="close"
          >开始修正文档</el-button
        >
        <el-button type="primary" size="medium" plain @click="showErrata"
          >输出勘误表</el-button
        >
      </div>
      <div class="success" v-else>
        <div class="total">恭喜您，本次校对未发现错误</div>
        <el-button type="primary" size="medium" plain @click="close"
          >确定</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import dlgFunc from "./index.js";
import proofread from "../../utils/mixin/proofread.js";

export default {
  name: "textProofreading",
  mixins: [proofread],
  data() {
    return {
      errorTypeCount: 0,
    };
  },
  methods: {
    inspect() {
      let count = 0, obj;
      if(setingDefault.splittype == 1) {
        obj = dlgFunc.CWps.Application.ActiveDocument.Paragraphs;
        count = obj.Count;
      } else {
        obj = dlgFunc.CWps.Application.ActiveDocument.Sentences;
        count = obj.Count;
      }
      this.getProofreading(obj, count);
    },
  },
};
</script>

<style scoped>
.loading_box {
  padding: 10px;
  height: 100%;
}

.percentage_ {
  display: flex;
  align-items: center;
}

.percentage {
  flex: 1;
}

.textProofreading {
  height: 90%;
}

.content {
  height: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 20px;
  text-align: center;
}

.total {
  font-size: 16px;
  margin-bottom: 12px;
}

.error,
.success {
  width: 100%;
  font-size: 12px;
}
</style>
